// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"775":"c276c237","863":"3fb1d0c2","899":"f16a8a6e","923":"aa78e271"}[chunkId] + ".chunk.js";
};